import React from "react";

import { AssociateContentStandaloneForm } from "../../../../../../../../content-ingestion/common/content/forms/AssociateContentStandaloneForm";
import { BulkEditCloudAssetContentConfirmDialog } from "./BulkEditCloudAssetContentConfirmDialog";
import { useBulkEditCloudAssetContentForm } from "./useBulkEditCloudAssetContentForm";

export const BulkEditCloudAssetContentForm = (): JSX.Element => {
    const {
        assetId,
        defaultContentState,
        isDefaultContentLoading,
        pendingContentReference,
        isConfirmDialogOpen,
        onSubmit,
        closeConfirmDialog,
        backToAssetsSearch,
        backToAssetDetails
    } = useBulkEditCloudAssetContentForm();

    return (
        <>
            <AssociateContentStandaloneForm
                formTitle="Bulk edit content"
                onSubmit={onSubmit}
                onCancel={backToAssetDetails}
                isDefaultContentLoading={isDefaultContentLoading}
                defaultContentState={defaultContentState}
                infoMessage={infoMessage}
            />
            {pendingContentReference && (
                <BulkEditCloudAssetContentConfirmDialog
                    isOpen={isConfirmDialogOpen}
                    assetId={assetId}
                    contentReference={pendingContentReference}
                    onClose={closeConfirmDialog}
                    onHandleConfirmation={backToAssetsSearch}
                />
            )}
        </>
    );
};

const infoMessage =
    "All assets belonging to this asset group will be moved to the target content version. New assets will be created on submit and existing ones will be deprecated. Please make sure all information is correct.";
